import script from "./ai-menu-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-menu-setting.vue?vue&type=script&setup=true&lang=js"

import "./ai-menu-setting.vue?vue&type=style&index=0&id=6d35fc35&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d35fc35"]])

export default __exports__